export default "__VITE_ASSET__uOtg8g_a__"